
import React, { useState, useRef, useEffect } from 'react';
import { isNil } from 'lodash';
import { connect } from 'react-redux';
import { expandLeftToolbar } from '../../../action/left-toolbar-state-actions';
import { markerUpdate, markerDeleteRequest } from '../../../action/marker-actions';
import { disableMapObject, enableMapObject } from '../../../action/disable-map-obj-state-action';
import { expandRightToolbar } from '../../../action/right-toolbar-state-actions';
import './index.css';
import { infoWindowOpenAction } from '../../../action/infowindow-action';
import { selectedObjectId, selectedObjectIdNull } from '../../../action/map-object-id';
import { clearMarkerOpeners, setMarkerOpener } from '../../../lib/marker-openers';
import { createContent, buildContent } from '../commonFunctions';
import { collapseLeftToolbar } from '../../../action/left-toolbar-state-actions';
import ConfirmRemoval from '../../../component/main-ui/left-toolbar/common/confirm-remove/index';
import sharedCluster, { rebuildCluster } from '../sharedMarkerCluster';
import { contentVisibilityKey } from '../../../action/hidden-content-ids-actions';
import { visibleActiveVendors } from '../../../lib/layerVisibility'

const RenderMarkers = (props) => {
  const [comfirmRemove, setComfirmRemove] = useState(false);
  const [deleteMarkerId, setDeleteMarkerId] = useState({});
  const [infowindowsState, setInfowindowsState] = useState(null);
  const [previousState, setPreviousState] = useState(null);

  const nulTheMapRef = useRef(null);
  const markerRefs = useRef({});
  const markerClusterRef = useRef(null);

  const {
    expandLeftToolbar,
    markers,
    mapReference,
    markerTypes25,
    vendors,
    activeVendors,
    auth,
    markerDeleteRequest,
    leftToolbarState,
    expandRightToolbar,
    infoWindowOpenAction,
    infoWindow,
    selectedObjectId,
    selectedObjectIdNull,
    collapseLeftToolbar,
    hiddenContentTypes,
    hiddenContentIds,
  } = props;

  let openInfoWindow = null;
  const token = auth.token;

  const handleRemoveFunction = () => {
    if (nulTheMapRef.current) {
      nulTheMapRef.current(deleteMarkerId.value);
      setComfirmRemove(false);
    }
  };

  useEffect(() => {
    if (previousState) {
      previousState.close();
    }
    setPreviousState(infowindowsState);
  }, [infowindowsState]);

  const storeInfoBox = (value) => {
    setInfowindowsState(value);
    infoWindowOpenAction(value);
  };

  const mapFunction = async (toAdd) => {
    const { AdvancedMarkerElement } = await window.google.maps.importLibrary("marker");

    // Clear previous markers
    Object.values(markerRefs.current).forEach((marker) => {
      marker.map = null;
    });
    markerRefs.current = {};
    clearMarkerOpeners();

    // Cluster will be rebuilt via rebuildCluster at the end

    const markersToAdd = [];

    toAdd.forEach((rawMarker) => {
      const marker = { ...rawMarker }; // clone to avoid Redux mutation

      const url = marker.markerType.vectorIconUrl || marker.markerType.iconUrl;
      const color = marker.color;
      marker['measureType'] = 'marker'


      const mapObj = new AdvancedMarkerElement({
        content: buildContent(url, color),
        position: { lat: marker.latitude, lng: marker.longitude },
        title: marker.name,
        gmpClickable: true,
      });
      marker['mapObj'] = function () { return mapObj; };

      const handleClick = () => {
        selectedObjectId(marker.id);
        console.log('onclick is called')
        const editFunction = (infoWindow) => {
          console.log(marker, '=======================>editable')
          collapseLeftToolbar();
          expandLeftToolbar({ dialog: 'edit', editable: marker, mapObj });
          openInfoWindow = infoWindow;
          openInfoWindow.close();
          mapReference.setCenter({ lat: marker.latitude, lng: marker.longitude });
          mapReference.setZoom(17);
          selectedObjectIdNull();
        };

        const editHuntWind = (infoWindow) => {
          collapseLeftToolbar();
          marker.huntWind = true;
          expandRightToolbar({ dialog: 'huntWind', data: marker });
          openInfoWindow = infoWindow;
          openInfoWindow.close();
          setInfowindowsState(null);
          selectedObjectIdNull();
        };

        const nulTheMap = async (value) => {
          try {
            await markerDeleteRequest(value);
            mapObj.map = null;
          } catch (error) {
            console.error('Error at deleteFunction', error);
          }
        };

        const deleteFunction = (value) => {
          setDeleteMarkerId({ value, mapObj });
          setComfirmRemove(true);
          openInfoWindow?.close();
          nulTheMapRef.current = nulTheMap;
          setInfowindowsState(null);
          selectedObjectIdNull();
        };

        const closeFunction = (infoWindow) => {
          openInfoWindow = infoWindow;
          openInfoWindow.close();
          setInfowindowsState(null);
          selectedObjectIdNull();
        };

        const updateInfoWindow = (value) => {
          openInfoWindow = value;
        };

        const dispatchFunction = (value) => {
          storeInfoBox(value);
        };

        createContent(
          { mapReference, mapObj, marker, infoWindow, openInfoWindow, token },
          {
            deleteFunction,
            closeFunction,
            editFunction,
            updateInfoWindow,
            editHuntWind,
          },
          dispatchFunction
        );
      };

      mapObj.addListener('gmp-click', handleClick);

      markerRefs.current[marker.id] = mapObj;
      // So a map deep link can open this marker as a click would (WEB-7109).
      setMarkerOpener(marker.id, handleClick);
      markersToAdd.push(mapObj);
    });

    sharedCluster.regularMarkers = markersToAdd;
    rebuildCluster(mapReference);
    markerClusterRef.current = sharedCluster.instance;
  };

  useEffect(() => {
    if (markerTypes25?.length && mapReference) {
      const vendorMarkers = activeVendors.flatMap(
        (id) => vendors[id]?.objects?.markers || []
      );

      // Respect the My Content per-type show/hide. Markers and hunt stands share
      // state.markers and are split by markerType.usageFlag (== 3 is a hunt stand),
      // so each hides independently. Vendor markers are not My Content and are
      // unaffected. mapFunction fully tears down and rebuilds, so filtering here
      // hides on toggle; re-showing re-runs this effect (hiddenContentTypes dep).
      const hideMarkers = hiddenContentTypes.includes('markers');
      const hideHuntStands = hiddenContentTypes.includes('huntStands');
      const visibleMarkers = markers.filter((m) => {
        if (!m || !m.markerType) return false;
        // Per-object "Hide on Map" (WEB-7047) — takes precedence over the type toggle.
        if (hiddenContentIds.includes(contentVisibilityKey('marker', m.id))) return false;
        return m.markerType.usageFlag == 3 ? !hideHuntStands : !hideMarkers;
      });

      const toAdd = [...visibleMarkers, ...vendorMarkers];
      mapFunction(toAdd);
    }
  }, [markerTypes25, mapReference, markers, activeVendors, vendors, hiddenContentTypes, hiddenContentIds]);

  if (comfirmRemove) {
    return (
      <ConfirmRemoval
        cancel={() => setComfirmRemove(false)}
        remove={handleRemoveFunction}
        type="Marker"
      />
    );
  }

  return null;
};

const mapStateToProps = state => ({
  vendors: state.vendors,
  // Hidden by the global layers eye toggle along with the layers they came from (WEB-7048).
  activeVendors: visibleActiveVendors(state),
  leftToolbarState: state.leftToolbarState,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
  markers: state.markers,
  markerTypes25: state.markerTypes25,
  auth: state.auth,
  infoWindow: state.infoWindow,
  hiddenContentTypes: state.hiddenContentTypes,
  hiddenContentIds: state.hiddenContentIds,
});

const mapDispatchToProps = dispatch => ({
  expandLeftToolbar: props => dispatch(expandLeftToolbar(props)),
  markerUpdate: marker => dispatch(markerUpdate(marker)),
  markerDeleteRequest: id => dispatch(markerDeleteRequest(id)),
  enableMapObject: () => dispatch(enableMapObject()),
  disableMapObject: () => dispatch(disableMapObject()),
  expandRightToolbar: props => dispatch(expandRightToolbar(props)),
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar()),
  infoWindowOpenAction: payload => dispatch(infoWindowOpenAction(payload)),
  selectedObjectId: payload => dispatch(selectedObjectId(payload)),
  selectedObjectIdNull: () => dispatch(selectedObjectIdNull()),
});

export default connect(mapStateToProps, mapDispatchToProps)(RenderMarkers);
